<div class="ml-5">
  <p class="titre1 m-4">
    {{ 'AIDE_ET_SOUTIEN.TITLE' | translate }}
    <mat-icon
    class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">help</mat-icon>
  </p>
  <div class="container mx-auto">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      <app-managment-card [title]="'AIDE_ET_SOUTIEN.TUTORIELS' | translate" [textColor]="'text-white'"
        [bgColor]="'bg-vertTutorielsNovo'" [icon]="'book'" [routerLink]="'/aide-et-soutien/tutoriels'">
      </app-managment-card>
      <app-managment-card [title]="'AIDE_ET_SOUTIEN.NOUS_CONTACTER' | translate" [textColor]="'text-white'"
        [bgColor]="'bg-bleuContactNovo'" [icon]="'mail'" [routerLink]="'/aide-et-soutien/nous-contacter'">
      </app-managment-card>
      @if (afficherPrendreRv) {
        <app-managment-card [title]="'AIDE_ET_SOUTIEN.PRENDRE_RV' | translate"
          [textColor]="'text-white'" [bgColor]="'bg-bleuCalendrierNovo'" [icon]="'calendar_clock'"
          [externalUrl]="rdvUrl">
        </app-managment-card>
      }
      <app-managment-card [title]="'AIDE_ET_SOUTIEN.CONDITIONS' | translate" [textColor]="'text-white'"
        [bgColor]="'bg-rougeConditionsNovo'" [icon]="'docs'" [externalUrl]="conditionsUrl">
      </app-managment-card>
      <app-managment-card [title]="'AIDE_ET_SOUTIEN.NOTES_VERSION' | translate" [textColor]="'text-white'"
        [bgColor]="'bg-orangeNovo'" [icon]="'edit_note'" [routerLink]="'/aide-et-soutien/notes-de-version'">
      </app-managment-card>
    </div>
  </div>
</div>